import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/InterchangeScreenModels'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class InterchangeScreenModelsStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "InterchangeScreenModelsStore",
			variables: false,
		})
	}
}

export async function load_InterchangeScreenModels(params) {
  await initClient()

	const store = new InterchangeScreenModelsStore()

	await store.fetch(params)

	return {
		InterchangeScreenModels: store,
	}
}
